module.exports = __webpack_public_path__ + "static/media/rcs.svg-removebg-preview.a7e62726.png";